import { z } from 'zod'
import { oc } from '@orpc/contract'

const enrichedRowSchema = z.object({
  name: z.string(),
  address: z.string().optional(),
  phone: z.string().optional(),
  fax: z.string().optional(),
  source: z.enum(['npi', 'ai', 'none']),
  sources: z
    .object({
      address: z.string().optional(),
      phone: z.string().optional(),
      fax: z.string().optional(),
    })
    .optional(),
})

const enrichmentSchema = z.object({
  providers: z.array(enrichedRowSchema),
  locations: z.array(enrichedRowSchema),
  generatedAt: z.string(),
  status: z.enum(['running', 'complete', 'failed']),
  progress: z.object({ completed: z.number(), total: z.number() }).optional(),
  /** Always absent here (a run refreshes everything); kept so all three
   * record-locator endpoints return the same enrichment shape. */
  providersStale: z.boolean().optional(),
})

export const runRecordLocatorEnrichment = oc
  .route({ method: 'POST', path: '/v2/patients/{patientId}/record-locator/run' })
  .input(z.object({ patientId: z.string() }))
  .output(enrichmentSchema)
